import { styled } from "../../theme";

export const Divider = styled("hr", {
  width: "100%",
  height: "1px",
  backgroundColor: "$neutral-bg-medium",
  border: "none",
  my: "$0",
});
